import { useLang } from "@/context/LanguageContext";
import { LegalLinks } from "@/components/LegalLinks";

export const Footer = ({ legal = false }) => {
  const { t } = useLang();
  return (
    <footer className="mt-20 border-t border-border bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <img src="/brand/logo.png" alt="SkillCity" className="h-8 w-8 rounded-lg object-cover" />
          <span className="font-display text-lg font-extrabold">Skill<span className="text-primary">City</span></span>
        </div>

        <div className="flex flex-col items-center text-center gap-2" data-testid="footer-social">
          <p className="font-display font-bold text-slate-900 dark:text-white">{t("footer.follow")}</p>
          <div className="flex items-center gap-3">
            <a href="https://www.facebook.com/profile.php?id=61590451352982" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="transition-transform hover:scale-110">
              <img src="/social/facebook.png" alt="Facebook" className="h-9 w-9 rounded-xl" />
            </a>
            <a href="https://www.instagram.com/skillcityapp/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="transition-transform hover:scale-110">
              <img src="/social/instagram.png" alt="Instagram" className="h-9 w-9 rounded-xl" />
            </a>
          </div>
          <p className="text-xs text-muted-foreground">{t("footer.followTags")}</p>
        </div>

        <p className="text-sm text-muted-foreground text-center sm:text-right">
          © {new Date().getFullYear()} SkillCity · {t("footer.tagline")}
        </p>
      </div>
      {legal && <div className="max-w-7xl mx-auto px-4 pb-6 -mt-4"><LegalLinks /></div>}
    </footer>
  );
};
